import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import Selectors from '../selectors';
import Actions from '../action';

import AddEditCampaignPresentational from './add-edit-campaign-presentational';

const AddEditCampaignFunctional = ({ userDetails, getCampaignDropdown, campaignDDList, campaignDDListLoading, addCampaign, addCampaignLoading }) => {
	const [campaign, setcampaign] = useState({
		step1Commission: '',
		step2Commission: '',
		cpcCommission: '',
	});
	const [selectedCampaignList, setSelectedCampaignList] = useState([]);
	const [sourceValues, setSourceValues] = useState({ sourceValue1: '', sourceValue2: '', sourceValue3: '', sourceValue4: '', sourceValue5: '' });
	const [domains, setdomains] = useState(
		Array(0)
			.fill('')
			.map((data, i) => {
				return {
					key: i,
					domain: 'www.google.com',
				};
			})
	);
	const { type, affId, affiliateId } = useParams();
	const history = useHistory();
	const [value, setValue] = useState(1);

	const handleDropdownChange = (value) => {
		setSelectedCampaignList(value);
	};

	const onChange = (e) => {
		setValue(e.target.value);
	};

	const handleChange = ({ target: { name, value } }, isSourceValue = false) => {
		if (!isSourceValue) {
			setcampaign({
				...campaign,
				[name]: value,
			});
		} else {
			setSourceValues({
				...sourceValues,
				[name]: value,
			});
		}
	};

	const addDomain = (domain) => {
		const tempDomains = domains;
		tempDomains.unshift({
			key: tempDomains.length,
			domain,
		});
		setdomains([...tempDomains]);
	};
	const editDomain = (data) => {
		const elementsIndex = domains.findIndex((todo) => todo.key === data.key);
		let newArray = [...domains];
		newArray[elementsIndex] = { ...newArray[elementsIndex], domain: data.domain };
		setdomains(newArray);
	};
	const removeDomain = (key) => {
		const tempDomains = domains.filter((domain) => domain.key !== key);
		setdomains([...tempDomains]);
	};

	const saveCampaign = () => {
		if (userDetails) {
			addCampaign(
				{
					authKey: userDetails.authKey,
					companyId: userDetails.companyId,
					sourceId: parseInt(affId),
					campaignId: selectedCampaignList,
					domainName: domains.map((domain) => domain.domain),
					...campaign,
					...sourceValues,
				},
				history
			);
		}
	};

	useEffect(() => {
		getCampaignDropdown(userDetails && userDetails.companyId, history);
	}, []);

	return (
		<AddEditCampaignPresentational
			addCampaignLoading={addCampaignLoading}
			onChange={onChange}
			sourceValues={sourceValues}
			affId={affId}
			affiliateId={affiliateId}
			value={value}
			type={type}
			history={history}
			domains={domains}
			campaign={campaign}
			removeDomain={removeDomain}
			handleDropdownChange={handleDropdownChange}
			addDomain={addDomain}
			editDomain={editDomain}
			handleChange={handleChange}
			saveCampaign={saveCampaign}
			campaignDDList={campaignDDList}
			campaignDDListLoading={campaignDDListLoading}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: SelectorsApp.userDetails(state),
		campaignDDList: Selectors.campaignDDList(state),
		campaignDDListLoading: Selectors.campaignDDListLoading(state),
		addCampaignLoading: Selectors.addCampaignLoading(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getCampaignDropdown: (companyId, history) => dispatch(Actions.creators.getCampaignDropdown(companyId, history)),
		addCampaign: (request, history) => dispatch(Actions.creators.addCampaign(request, history)),
	};
};
const Connected = connect(mapStateToProps, mapDispatchToProps)(AddEditCampaignFunctional);

export default Connected;
